import Vue from "vue";
import router from "vue-router";
import store from "../store/index.js"

Vue.use(router);

/* 定义组件路由 */
var rout = new router({
	routes: [
    {
		path: '/', //登录页
		name: 'login',
		component: () => import('../views/login/index.vue'),
	}, {
		path: '/',
		name: 'main',
		component: () => import('../views/main.vue'),
		redirect: "/home",//重定向首页
		children: [{
				path: 'home', //首页
				name: '首页',
				meta: {
					href:'/home'
				},
				component: () => import('../views/home/index.vue'),
			},
			{
				path: 'archivesList', //(客户-档案模块)档案列表
				name:'客户档案',
				meta: {
					href:'/consumer'
				},
				component: () => import('../views/customer/archivesList/index.vue'),
			},
			{
				path: 'infoUphold', //(客户-档案模块)本公司信息维护
				name:'平台信息设置',
				meta: {href:'/home', tip: '本公司档案信息管理'},
				component: () => import('../views/customer/infoUphold/index.vue'),
			},
			{
				path: 'followUprecords', //(客户-拜访模块)客户跟进录入
				name:'客户跟进录入',
				meta: {
					href:'/consumer'
				},
				component: () => import('../views/customer/followUprecords/index.vue'),
			},
			{
				path: 'supplierList', //(客户-供应商模块)供应商家列表
				name:'供应商列表',
				meta: {
					href:'/consumer'
				},
				component: () => import('../views/customer/supplierList/index.vue'),
			},
			{
				path: 'productLibrary', //(货源-商品模块)商品库
				name:'商品库',
				meta: { href:'/sourceGoods', tip: '综合商品库的管理。平台自营商品需创建，供应链商品从接口获取，供应商商品由供应商上传，礼卡从商城创建' },
				component: () => import('../views/sourceGoods/productLibrary/index.vue'),
			},
			{
				path: 'goodCategory', //(货源-商品模块)商品分类
				name:'商品分类',
				meta: {href:'/sourceGoods', tip: '商品类型管理'},
				component: () => import('../views/sourceGoods/goodCategory/index.vue'),
			},
			{
				path: 'goodPricing', //(货源-商品模块)商品定价
				name:'商品定价',
				meta: { href:'/sourceGoods', tip: '对商城中商品的价格进行综合定价管理，从利润率角度，以批量快速调整商品价格' },
				component: () => import('../views/sourceGoods/goodPricing/index.vue'),
			},
			{
				path: 'goodInventory', //(货源-商品模块)商品库存
				name:'商品库存',
				meta: {href:'/sourceGoods', tip: '对库内商品存量的管理'},
				component: () => import('../views/sourceGoods/goodInventory/index.vue'),
			},
            {
				path: 'inventory', //(货源-商品模块)商品库存
				name:'出入库单',
				meta: {href:'/sourceGoods', tip: '在财务收款时，触发业务提成的计算，业务提成明细记录'},
				component: () => import('../views/sourceGoods/inventory.vue'),
			},
            {
				path: 'inventoryLog', //(货源-商品模块)商品库存
				name:'出入库日志',
				meta: {href:'/sourceGoods', tip: '在财务收款时，触发业务提成的计算，业务提成明细记录'},
				component: () => import('../views/sourceGoods/inventoryLog.vue'),
			},
            {
				path: 'inventoryCount', //(货源-商品模块)商品库存
				name:'出入库统计',
				meta: { href:'/sourceGoods', tip: '对出入库商品记录进行分析' },
				component: () => import('../views/sourceGoods/inventoryCount.vue'),
			},
			{
				path: 'supplyConfig', //(货源-供应商模块)供应链配置
				name:'供应链配置',
				meta: { href:'/sourceGoods', tip: '在与供应链平台业务开通后，进行配置' },
				component: () => import('../views/sourceGoods/supplyConfig/index.vue'),
			},
			{
				path: 'vvbSupply', //(货源-供应商模块)微唯宝供应链
				name:'微唯宝供应链',
				meta: {
					href:'/sourceGoods'
				},
				component: () => import('../views/sourceGoods/vvbSupply/index.vue'),
			},
			{
				path: 'vvbOnlineSelection', //(货源-供应商模块)微唯宝在线选品
				name:'微唯宝在线选品',
				meta: {
					href:'/sourceGoods'
				},
				component: () => import('../views/sourceGoods/vvbOnlineSelection/index.vue'),
			},
			{
				path: 'couponList', //(货源-礼卡模块)礼卡券列表
				name:'礼卡券列表',
				meta: { href:'/sourceGoods', tip: '礼卡券列表，对礼卡券进行管理' },
				component: () => import('../views/sourceGoods/couponList/index.vue'),
			},
			{
				path: 'couponDesign', //(货源-礼卡模块)在线制卡
				component: () => import('../views/sourceGoods/couponDesign/index.vue'),
			},
			{
				path: 'myDesignCoupon', //(货源-礼卡模块)我的制卡
				name:'我的制卡',
				meta: { href:'/sourceGoods', tip: '向平台申请制作实体卡券进程管理。（提示：提交申请后，请联系客服，确认并付款，再进行实卡制作）' },
				component: () => import('../views/sourceGoods/myDesignCoupon/index.vue'),
			},
			{
				path: 'albumCollectList', //(货源-册集模块)产品册集列表
				name:'产品册集列表',
				meta: { href:'/sourceGoods', tip: '创建商品册集给客户报价，可导出生成PDF，或在线链接访问' },
				component: () => import('../views/sourceGoods/albumCollectList/index.vue'),
			},
			{
				path: 'albumCollectCreate', //(货源-册集模块)册集创建
				name:'创建册集',
				meta: { href:'/sourceGoods', tip: '制作商品的价格报价册（货盘表）' },
				component: () => import('../views/sourceGoods/albumCollectCreate/index.vue'),
			},
			{
				path: 'opportunity', //(业务-采集模块)业务商机
				name:'业务商机',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/opportunity/index.vue'),
			},
			{
				path: 'stockUpEnquiry', //(业务-采集模块)备货/询价
				name:'备货/询价',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/stockUpEnquiry/index.vue'),
			},
			{
				path: 'clientQuotation', //(业务-采集模块)客户报价
				name:'客户报价',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/clientQuotation/index.vue'),
			},
			{
				path: 'clientContract', //(业务-采集模块)客户合同
				name:'客户合同',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/clientContract/index.vue'),
			},
			{
				path: 'goodCollect', //(业务-采集模块)商品采集
				name:'商品采集',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/goodCollect/index.vue'),
			},
			{
				path: 'goodExWarehouse', //(业务-采集模块)商品出库
				name:'商品出库',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/goodExWarehouse/index.vue'),
			},
			{
				path: 'paymentReceipt', //(业务-采集模块)收付款据
				name:'收付款据',
				meta: { href:'/business', tip: '公司运营时产品的费用支出和业务收入的财务记录' },
				component: () => import('../views/business/paymentReceipt/index.vue'),
			},
			{
				path: 'invoiceApplyFor', //(业务-采集模块)发票申请
				name:'发票申请',
				meta: { href:'/business', tip: '发起发票开具申请。历史申请记录' },
				component: () => import('../views/business/invoiceApplyFor/index.vue'),
			},
			{
				path: 'commissionPlan', //(业务-财务模块)提成方案
				name:'提成方案',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/commissionPlan/index.vue'),
			},
			{
				path: 'commissionDetails', //(业务-财务模块)提成明细
				name:'提成明细',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/commissionDetails/index.vue'),
			},
			{
				path: 'businessCount', //(业务-财务模块)业务统计
				name:'业务统计',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/businessCount/index.vue'),
			},
			{
				path: 'supplierSetAccount', //(业务-财务模块)供应商结算
				name:'供应商结算',
				meta: {
					href:'/business'
				},
				component: () => import('../views/business/supplierSetAccount/index.vue'),
			},
			{
				path: 'paymentCount', //(业务-财务模块)收付款统计
				name:'收付款统计',
				meta: { href:'/business', tip: '对账户收付款记录进行分析' },
				component: () => import('../views/business/paymentCount/index.vue'),
			},
			{
				path: 'paymentCategory', //(业务-财务模块)收支类目维护
                name:'收支类目',
				meta: { href:'/coordination', type: '用于维护收款的类目，便于分类统计' },
				component: () => import('../views/business/paymentCategory/index.vue'),
			},
			{
				path: 'schedule', //(协同-新申请模块)待办事项
				name:'待办事项',
				meta: { href:'/coordination' },
				component: () => import('../views/coordination/schedule/index.vue'),
			},
			{
				path: 'approvalManage', //(协同-我审批模块)审批申请管理
				name:'我的审批',
				meta: { href:'/coordination', tip: '指派给我审批的申请，由我处理' },
				component: () => import('../views/coordination/approvalManage/index.vue'),
			},
			{
				path: 'myInitiate', //(协同-我提交模块)我发起的申请
				name:'我的申请',
				meta: { href:'/coordination', tip: '由我创建的申请，查看进度及处理结果' },
				component: () => import('../views/coordination/myInitiate/index.vue'),
			},
			{
				path: 'organizationalStructure', //(首页-权限)组织架构
				name: '组织架构',
				meta: {
					href:'/home',
                    tip: '对公司整体部门框架及员工账号集中管理'
				},
				component: () => import('@/views/basic/organization.vue'),
			},
			{
				path: 'permissionRole', //(首页-权限)权限角色
				name: '权限角色',
				meta: { href:'/home', tip: '员工岗位及功能的配置管理', },
				component: () => import('../views/coordination/permissionRole/index.vue'),
			},
			{
				path: 'operationLog', //(首页-权限)操作日志
				name: '操作日志',
				meta: { href:'/home', tip: '账号历史操作记录', },
				component: () => import('../views/coordination/operationLog/index.vue'),
			},
			{
				path: 'approvalTemplate', //(协同-管理模块)流程审批模板
				name:'审批流程',
				meta: { href:'/coordination', tip: '企业日常事项审批流程的模板管理' },
				component: () => import('../views/coordination/approvalTemplate/index1.vue'),
			},
			{
				path: 'initiateRecord', //(协同-管理模块)申请记录
				name:'申请记录',
				meta: { href:'/coordination', tip: '企业日常事项审批流程综合记录' },
				component: () => import('../views/coordination/initiateRecord/index.vue'),
			},
			{
				path: 'shopMallMange', //(商城-新开模块)商城管理
				name:'商城管理',
				meta: { href:'/shopMall', tip: '公司可以创建多个商城，用于企业采购和用户积分消耗。开设更多商城请联系业务人员' },
				component: () => import('../views/shopMall/shopMallMange/index.vue'),
			},
			{
				path: 'productOrders', //(商城-发货模块)自营商品订单
				name:'商城-商品订单',
				meta: { href:'/shopMall', tip: '综合对商城中多种分类类型的管理' },
				component: () => import('../views/shopMall/productOrders/index.vue'),
			},
			{
				path: 'goodsAfterSale', //(商城-发货模块)自营商品订单
				name:'商城-订单售后',
				meta: { href:'/shopMall', tip: '用户在商城端订单管理中，对有问题商品发起售后，在此页面进行综合售后处理' },
				component: () => import('../views/shopMall/goodsAfterSale/index.vue'),
			},
			{
				path: 'platproductOrders', //(商城-发货模块)自营商品订单
				name:'自营订单',
				meta: {
					href:'/shopMall'
				},
				component: () => import('../views/shopMall/productOrders/index.vue'),
			},
			{
				path: 'platgoodsAfterSale', //(商城-发货模块)自营商品订单
				name:'自营售后',
				meta: {
					href:'/shopMall'
				},
				component: () => import('../views/shopMall/goodsAfterSale/index.vue'),
			},
			{
				path: 'shopBill', //(商城-发货模块)自营商品订单
				name:'账户流水',
				meta: {
					href:'/shopMall'
				},
				component: () => import('../views/shopMall/shop/bill.vue'),
			},
			{
				path: 'shopStatistics', //(商城-发货模块)自营商品订单
				name:'商品销售',
				meta: {
					href:'/shopMall'
				},
				component: () => import('../views/shopMall/shop/statistics.vue'),
			},
			{
				path: 'shopSurvey', //(商城-发货模块)自营商品订单
				name:'经营概况',
				meta: {
					href:'/shopMall'
				},
				component: () => import('../views/shopMall/shop/survey.vue'),
			},
			{
				path: 'goodManage', //(供应商-商品模块)商品管理
				name:'供应商-商品管理',
				meta: {
					href:'/supplier'
				},
				component: () => import('../views/sourceGoods/productLibrary/index.vue'),
				// component: () => import('../views/supplier/goodManage/index.vue'),
			},
			{
				path: 'orderManage', //(供应商-订单模块)订单管理
				name:'供应商-订单管理',
				meta: {
					href:'/supplier'
				},
				component: () => import('../views/shopMall/productOrders/index.vue'),
				// component: () => import('../views/supplier/orderManage/index.vue'),
			},
			{
				path: 'orderAfterSale', //(供应商-订单模块)订单售后
				name:'供应商-订单售后',
				meta: {
					href:'/supplier'
				},
				component: () => import('../views/supplier/orderAfterSale/index.vue'),
			},
			{
				path: 'saleCount', //(供应商-财务模块)货品销售统计
				name:'货品销售统计',
				meta: {
					href:'/supplier'
				},
				component: () => import('../views/supplier/saleCount/index.vue'),
			},
			{
				path: 'settlementDocList', //(供应商-财务模块)结算单列表
				name:'结算单列表',
				meta: {
					href:'/supplier'
				},
				component: () => import('../views/supplier/settlementDocList/index.vue'),
			},

            {
				path: 'crmindex',
				name:'控制台',
				component: () => import('@/views/home/crm.vue'),
			},
            {
				path: 'document',
				name:'文档通知',
                meta: { tip: '企业内部公告，及学习培训文档中心' },
				component: () => import('@/views/article/document.vue'),
			},
            {
				path: 'archive',
				name:'文档',
                meta: { tip: '企业内部资料的管理，用于员工培训与学习' },
				component: () => import('@/views/article/notice.vue'),
			},
            {
				path: 'notice',
				name:'通知',
                meta: { tip: '企业内部通知公告,将展示在首页区域' },
				component: () => import('@/views/article/notice.vue'),
			},
            {
				path: 'sms',
				name:'短信',
                meta: { tip: '短信模板内容需要提前到短信宝后台提交审核' },
				component: () => import('@/views/article/sms.vue'),
			},
            {
				path: 'smsLogCount',
				name:'短信分析',
                meta: { tip: '对员工跟进记录的统计' },
				component: () => import('@/views/article/smsLogCount.vue'),
			},
            {
				path: 'source',
				name:'source',
				component: () => import('@/views/article/source.vue'),
			},
            {
				path: 'tag',
				name:'标签定义',
                meta: { tip: '对主要业务对象进行多纬度标签标识，每标识有多个候选值' },
				component: () => import('@/views/basic/tag.vue'),
			},

            {
				path: 'batch',
				name:'线索导入',
                meta: { tip: '将不同来源的线索数据，分批次导入，对导入数据的管理' },
				component: () => import('@/views/crmuser/batch.vue'),
			},
            {
				path: 'crmuser',
				name:'线索资源',
				meta: { href:'/supplier', tip: '线索信息管理，进行分配与回收。所属员工对线索进行跟进并记录' },
				component: () => import('@/views/crmuser/user.vue'),
			},
            {
                
                path: 'crmuserAnalysis',
				name:'线索分析',
				meta: { href:'/supplier', tip: '对按批次导入的线索记录进行分析' },
				component: () => import('@/views/crmuser/analysis.vue'),
            },
            {
                
                path: 'crmuserConversion',
				name:'线索转化',
				meta: { href:'/supplier', tip: '对按批次导入的线索记录进行分析' },
				component: () => import('@/views/crmuser/conversion.vue'),
            },
            {
                path: 'followChart',
				name:'跟进分析',
				meta: { href:'/supplier', tip: '对员工跟进记录的统计' },
				component: () => import('@/views/crmuser/followChart.vue'),
            },
            {
                path: 'followChartOne',
				name:'个人跟进',
				meta: { href:'/supplier', tip: '对员工跟进记录的统计' },
				component: () => import('@/views/crmuser/followChartOne.vue'),
            },
            {
				path: 'crmmechanism',
				name:'申请机制',
				meta: { href:'/supplier', tip: '对部门及员工，就线索和客户信息资源的分配，进行管制' },
				component: () => import('@/views/crmuser/mechanism.vue'),
			},
            {
				path: 'crmuserAppllyLists',
				name:'申请记录',
				meta: { href:'/supplier', tip: '员工申请获取用户资源线索记录的管理' },
				component: () => import('@/views/crmuser/record.vue'),
			},
            {
				path: 'level',
				name:'客户层级',
                meta: { tip: '为更精细开发客户，将各开发阶段的客户，定义层级' },
				component: () => import('@/views/crmuser/level.vue'),
			},
            {
				path: 'crmorder',
				name:'业务订单',
                meta: { tip: '业务订单综合管理' },
				component: () => import('@/views/crmorder/order.vue'),
			},
            {
                path: 'orderCount',
				name:'订单统计',
				meta: { href:'/supplier', tip: '对业务订单记录进行分析' },
				component: () => import('@/views/crmorder/orderCount.vue'),
            },
            {
                path: 'orderDepart',
				name:'部门订单统计',
				meta: { href:'/supplier', tip: '对业务订单记录进行分析' },
				component: () => import('@/views/crmorder/orderDepart.vue'),
            },
            {
                path: 'afterCount',
				name:'售后统计',
				meta: { href:'/supplier', tip: '对已发起售后的订单记录进行分析' },
				component: () => import('@/views/crmorder/afterCount.vue'),
            },
            {
                path: 'orderRank',
				name:'业绩排名',
				meta: { href:'/supplier', tip: '对员工业绩进行分析' },
				component: () => import('@/views/crmorder/orderRank.vue'),
            },
            {
                path: 'orderChart',
				name:'订单分析',
				meta: { href:'/supplier', tip: '对下单记录的统计' },
				component: () => import('@/views/crmorder/orderChart.vue'),
            },
            {
				path: 'logistics',
				name:'物流配置',
                meta: { tip: '配置第三方寄货查货接口' },
				component: () => import('@/views/crmorder/logistics.vue'),
			},
            {
				path: 'blacklist',
				name:'黑名单',
				component: () => import('@/views/crmorder/blacklist.vue'),
			},
            {
				path: 'commission',
				name:'提成方案',
                meta: { tip: '公司业务提成管理。在财务收款时，所关联合同的相关人员才会获得提成。一次收款，多个提成方案一并执行' },
				component: () => import('@/views/crmorder/commission.vue'),
			},
            {
                path: 'commission_statistics',
                name: '提成统计',
                meta: { tip: '对收款后所发放的提成记录进行分析' },
                component: () => import('@/views/crmorder/commission_statistics.vue')
            },
            {
                path: 'goodSaleCount',
                name: '商品销售统计',
                meta: { tip: '对订单中商品销售量进行分析' },
                component: () => import('@/views/crmorder/goodSaleCount.vue')
            },
            {
                path: 'system',
                name: '系统设置',
                meta: { tip: '系统功能设置管理' },
                component: () => import('@/views/basic/system.vue')
            },
		]
	}]
});

rout.beforeEach((to, from, next) => {
	var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
	if(loginInfo == null){
		loginInfo = store.state.loginInfo;
	}
	// 检查用户是否已登录
	if (!loginInfo.token) {
		// 如果用户未登录，重定向到登录页面
		if (to.path !== '/') {
			rout.push('/')
		}else{
			next();
		}
	} else {
		// 如果用户已登录，继续导航
		if(to.path === '/'){
			rout.go(0);
			localStorage.removeItem('loginInfo');
			localStorage.removeItem('tabIndex');
		}else{
			next();
		}
	}
});

//导出路由对象
export default rout;